module.exports = __webpack_public_path__ + "media/images/dubai-804fc3cdf0c0cc9994f7c4fcfe79a1c8.jpg";